import "./style.css";
import arrow from "../../assets/arrow.svg";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const BlogCard = ({ item }) => {
	const { t } = useTranslation();
	const lang = useSelector((state) => state?.lang?.lang);

	return (
		<div className="blog-card">
			<img src={item?.image} alt="blog-image" className="blog-image" />
			<div className="p-3">
				<p
					className="new-title"
					dangerouslySetInnerHTML={{
						__html: item[`title_${lang}`],
					}}></p>
				<p
					className="description"
					dangerouslySetInnerHTML={{
						__html: item[`description_${lang}`],
					}}></p>
				<p className="time d-flex mb-0 gap-12 align-items-center">
					<a
						className="time"
						target="_blank"
						href={item?.link}
						rel="noreferrer">
						{t("Read More")}
						<img src={arrow} alt="arrow" width={24} height={24} />
					</a>
				</p>
			</div>
		</div>
	);
};
export default BlogCard;
